import { FC } from 'react';
import { FundSelector } from 'pages/Firms/components/FundSelector';
import { useFundSelection } from './FirmSummaryAsyncCells.contexts';

/**
 * Fund column header selector. The fund list comes from GET /api/firms/{firm}/funds, which is
 * slow enough that threading it through the parser rebuilt the entire sheet when it resolved.
 */
const FundSelectorCell: FC = () => {
  const { fundsAvailable, selectedFund, setSelectedFund } = useFundSelection();

  return <FundSelector handleOnChange={setSelectedFund} options={fundsAvailable} value={selectedFund} />;
};

export default FundSelectorCell;
